// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__48rZx","importantInfo":"styles_importantInfo__2UNfN"};